<p-tabs [value]="activeIndex()" (valueChange)="onTabChange($event)">
  <p-tablist>
    <p-tab class="w-6 text-center" [value]="0">
      <div class="flex align-items-center justify-content-center gap-2">
        <i class="iconify icon-18 d-flex" [attr.data-icon]="'solar:user-hands-bold-duotone'"></i>Soy empleado
      </div>
    </p-tab>
    <p-tab class="w-6 text-center" [value]="1">
      <div class="flex align-items-center justify-content-center gap-2">
        <i class="iconify icon-18 d-flex" [attr.data-icon]="'solar:buildings-bold-duotone'"></i>Soy empresa
      </div>
    </p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="flex flex-column align-items-start pr-3 pl-3 pt-3 pb-0 w-full">
        <div class="flex w-full justify-content-between align-items-center mb-4">
          <h1 class="mb-2 mt-2" style="color: #0f2765">Iniciar sesión</h1>
        </div>
        <div class="w-full">
          <div class="w-full">
            <p class="m-0" style="color: #0f2765">Ingresa tu número de identificación para acceder como empleado.</p>
            <div class="w-12 my-2">
              <div miFormField [miCol]="12" class="p-0">
                <p-inputnumber placeholder="Ingresa tu número de identificación" [(ngModel)]="this.authStore.loginData().usuario" />
              </div>
            </div>
            <div class="flex w-full">
              <button
                miButton="primary"
                (click)="onLogin()"
                class="w-full justify-content-center"
                [miButtonIcon]="'solar:login-2-bold-duotone'"
              >
                Iniciar sesión
              </button>
            </div>

            <p class="mt-5 w-full mb-0 hiperlink" (click)="toLoginAzure()">Misión Empresarial Administrativo</p>
          </div>
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <div class="flex flex-column align-items-start pr-3 pl-3 pt-3 pb-0 w-full">
        <div class="flex w-full justify-content-between align-items-center mb-4">
          <h1 class="mb-2 mt-2" style="color: #0f2765">Iniciar sesión</h1>
        </div>
        <div class="w-full">
          <div class="w-full">
            <p class="m-0" style="color: #0f2765">Para iniciar sesión como <b>empresa</b>, ingresa tu correo electrónico registrado.</p>
            <div class="w-12 my-2">
              <div miFormField [miCol]="12" class="p-0">
                <input
                  type="text"
                  pInputText
                  placeholder="Ingresa tu correo electrónico"
                  [(ngModel)]="this.authStore.loginData().usuario"
                />
              </div>
            </div>
            <div class="flex w-full mb-4">
              <button
                miButton="primary"
                (click)="onLogin()"
                class="w-full justify-content-center"
                [miButtonIcon]="'solar:login-2-bold-duotone'"
              >
                Iniciar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<!-- @if (modalVideo) {
  <div class="video-modal-root" (click)="closeModalVideo()">
    <i
      class="iconify icon-36 close-video-modal"
      [attr.data-icon]="'solar:close-circle-broken'"
      role="button"
      aria-label="Cerrar video"
      tabindex="0"
    ></i>
    <div class="video-wrapper">
      <iframe
        class="youtube-player"
        [src]="urlVideo"
        title="Video de inicio de sesión"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      >
      </iframe>
    </div>
  </div>
} -->
